<template>
  <VProgressCircular
    v-if="type === 'circular'"
    :size="size"
    :color="color"
    indeterminate
    :class="className"
  ></VProgressCircular>
  <VProgressLinear
    v-else-if="type === 'linear'"
    :size="size"
    :color="color"
    indeterminate
    :class="className"
  ></VProgressLinear>
</template>

<script setup lang="ts">
const {
  type,
  size,
  color = 'primary',
  class: className
} = defineProps<{
  type: 'circular' | 'linear'
  size: 'small' | 'medium' | 'large'
  color?: string
  class?: string
}>()
</script>
